<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $t('messages.dashboard'),
                        href: meta.links.dashboard_index,
                    },
                    {
                        name: $tc('messages.bookmarks', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="w-full flex space-x-4 justify-end">
            <AppButton element="InertiaLink" :href="meta.links.create">
                {{ $t('messages.create') }}
            </AppButton>
        </div>

        <div>
            <AlertMessage class="mt-5 inline-block" type="info">
                <template v-slot:title>
                    {{ $t('messages.information') }}
                </template>
                <template v-slot:body>
                    {{ $t('messages.information_visible_by_all_teachers') }}
                </template>
            </AlertMessage>
        </div>

        <div class="flex flex-col mt-5">
            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                <div
                    class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                >
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead>
                            <tr>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.title') }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    <span class="sr-only">{{ $t('messages.actions') }}</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                v-for="(bookmark, index) in bookmarks.data"
                                :key="bookmark.id"
                            >
                                <td
                                    class="max-w-sm truncate px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                                >
                                    {{ bookmark.title }}
                                </td>
                                <td
                                    class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500 flex justify-end space-x-1"
                                >
                                    <InertiaSquareLinkButton action="external_link" :href="bookmark.url" element="a" />
                                    <InertiaSquareLinkButton action="edit" :href="bookmark.links.edit" />
                                    <InertiaSquareDeleteButton
                                        :href="bookmark.links.delete"
                                        :confirm-text="$t('messages.are_you_sure?')"
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <template v-slot:pagination>
            <InertiaPagination :paginator="bookmarks" />
        </template>
    </PanelPage>
</template>

<script>
import AdminLayout from '@/Shared/AdminLayout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import InertiaPagination from '@/Shared/InertiaPagination.vue';
import InertiaSquareLinkButton from '@/components/InertiaSquareLinkButton.vue';
import InertiaSquareDeleteButton from '@/components/InertiaSquareDeleteButton.vue';
import AlertMessage from '@/components/AlertMessage.vue';
import AppButton from '@/components/AppButton.vue';

export default {
    components: {
        AppButton,
        AlertMessage,
        PanelPage,
        InertiaPagination,
        InertiaSquareLinkButton,
        InertiaSquareDeleteButton,
    },
    layout: AdminLayout,
    name: 'Index',
    props: ['meta', 'bookmarks'],
    data() {
        return {};
    },
};
</script>
